// extracted by mini-css-extract-plugin
module.exports = {"checkboxLabel":"CheckboxItem_checkboxLabel__K6uc1","checkbox":"CheckboxItem_checkbox__lBAM9","icon":"CheckboxItem_icon__xGEb1"};